import React from 'react';

const SaveMoreWithRebates = () => {
    return (
        <div className="panel panel-default infobox">
            <div className="panel-body">
                <h4 className="text-primary">Save more with rebates</h4>
                <p>Find money-back rebates for choosing energy-efficient natural gas appliances and heating systems.</p>
                <i className="fa fa-angle-right icon-widget-gas" />
                <a id="link2"
                    href="http://www.fortisbc.com/Rebates/RebatesOffers/Pages/default.aspx"
                     className="link-widget box-link"  target="_blank"> Go to rebates & offers</a>
            </div>
        </div>
    );
};

export default SaveMoreWithRebates;


